<template>
  <div>
    <b-card no-header>
      <form>
        <b-form-group
          label="Número"
          label-for="numero"
          :labelCols="labelCols"
          horizontal>
          <b-form-input 
            id="numero"
            :value="remitoProximoNumero" 
            type="text"
            readonly>
          </b-form-input>
        </b-form-group>

      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Actualizar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'remito/getField',
  mutationType: 'remito/updateField',
});

export default {
  name: 'RemitosActualizacionNumeracion',
  props: {
    remitoId: {
      type: Number,
      default: 0,
    }
  },
  components: {
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  data () {
    return {
      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'remitoProximoNumero',
      'remitoFechaComprobante',
    ]),
  },
  created() {
    this.showSpinner();
    this.$store.dispatch('remito/inicializarParametrosActualizacion', this.remitoId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    save () {
      let save = true;
      
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;


      this.$v.$touch();

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          this.showSpinner();
          this.$store.dispatch('remito/actualizarNumeracion')
            .then(() => this.showModalMsj('La información del remito se actualizó con éxito', 
              this.close, this.close, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        }
      }
    },
    close() {
      this.$emit('close', true)
    },
    cancelar() {
      this.$emit('close', false)
    },
  },
  validations: {
  },  
  watch: {
  }    
}
</script>

<style>
</style>
